import SparkMD5 from 'spark-md5';

import { request } from './request';

/**
 * createMd5Hash creates an MD5 Hash of a file to be used as
 * a checksum when creating an image placeholder in the database
 */

const createMd5Hash = async (file: File) => {
  const arrayBuffer = new Uint8Array(await file.arrayBuffer());
  const md5Buffer = new SparkMD5.ArrayBuffer();

  md5Buffer.append(arrayBuffer);
  const binaryDigest = md5Buffer.end(true);
  return window.btoa(binaryDigest);
};

/**
 * The following function uploads a file to a given url and
 * returns the response from the PUT request
 */

const uploadFileDirectly = ({
  file,
  uploadUrl,
  uploadHeaders = '',
  stripContentType = true,
}: {
  file: File;
  uploadUrl: string;
  uploadHeaders?: string;
  stripContentType: boolean;
}) => {
  const blob = new Blob([file], { type: file.type });

  return request(uploadUrl, {
    headers: uploadHeaders
      ? (JSON.parse(uploadHeaders) as HeadersInit)
      : undefined,
    method: 'PUT',
    body: stripContentType ? blob.slice() : blob,
  });
};

export { createMd5Hash, uploadFileDirectly };
